'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _findIndex = require('lodash/findIndex');

var _findIndex2 = _interopRequireDefault(_findIndex);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _uuid = require('uuid');

var _applicationState = require('../../../utils/applicationState');

var _SelfAdjustingTimer = require('../../../utils/SelfAdjustingTimer');

var _SelfAdjustingTimer2 = _interopRequireDefault(_SelfAdjustingTimer);

var _networkUrlBuilder = require('../../../utils/networkUrlBuilder');

var _networkUrlBuilder2 = _interopRequireDefault(_networkUrlBuilder);

var _constants = require('../../../utils/constants');

var _logger = require('../../../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _reporter = require('../../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _palSdkController = require('../../../targeting/palSdkController');

var _palSdkController2 = _interopRequireDefault(_palSdkController);

var _mediaEvents = require('../../media/mediaEvents');

var _mediaEvents2 = _interopRequireDefault(_mediaEvents);

var _Events = require('../../media/Events');

var _Events2 = _interopRequireDefault(_Events);

var _InstreamCompanionController = require('./InstreamCompanionController');

var _InstreamCompanionController2 = _interopRequireDefault(_InstreamCompanionController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ONE_SECOND = 1000;

/**
 * name: InstreamAvailsController
 *
 * description:
 *  This controller receives metadata for instream ads (e.g. data/dev/sampleInStreamAdsData.js).
 *  That metadata contains events (time based and action based) which need to be fired based on
 *  the session timer. The timer starts when new data is received. The timed events are identified
 *  by a startTimeInSeconds property and are added to the timedEventMap. The action event listeners
 *  are activated once a particular ad is in progress (between the times of starting end finishing).
 *
 * context:
 *  The web-tuner is responsible for identifying whether or not a stream has instream ads and
 *  acquiring that metadata. Gemini-web receives that data and passes it to mint via the
 *  handleInstreamAds function bringing us into the entry point here (processAdData)
 */

var InstreamAvailsController = function () {
  function InstreamAvailsController() {
    var _this = this;

    _classCallCheck(this, InstreamAvailsController);

    this.setInitialState = function () {
      _this.isInitiated = false;
      _this.queuedAdCollection = {};
      _this.timedEventMap = {};
      _this.actionEventListeners = {};
      _this.currentAdId = undefined;
      _this.currentSessionTime = 0;
      _this.paused = false;
      _this.sessionTimer = undefined;
      _this.canSendEvents = true;
      _this.adList = [];
      _this.currentAdBreakId = undefined;
      _this.companionController = undefined;
    };

    this.destroy = function () {
      // remove top level events
      (0, _applicationState.removeStateChangeListener)(_applicationState.State.tuneRequested, _this.onTuneRequested);
      (0, _applicationState.removeStateChangeListener)(_applicationState.State.playerStatus, _this.onPlayerStatusChange);

      if (_this.companionController) {
        _this.companionController.destroy();
      }

      // remove ad level events
      (0, _forEach2.default)(_this.queuedAdCollection, function (ad) {
        return _this.removeAdFromQueue(ad.adId);
      });
      _this.resetSessionTimer();

      // reset everything
      _this.setInitialState();
    };

    this.processAdData = function (_ref) {
      var avails = _ref.avails,
          playerPosition = _ref.playerPosition,
          forceUpdate = _ref.forceUpdate;

      if (_this.isInitiated && (!avails || avails.length < 1)) {
        _this.destroy();
        return;
      }

      if (!_this.isInitiated) {
        _this.sessionTimer = new _SelfAdjustingTimer2.default(_this.onTimeChange, ONE_SECOND);
        (0, _applicationState.addStateChangeListener)(_applicationState.State.tuneRequested, _this.onTuneRequested);
        (0, _applicationState.addStateChangeListener)(_applicationState.State.playerStatus, _this.onPlayerStatusChange);

        _this.companionController = new _InstreamCompanionController2.default();
        _this.isInitiated = true;
      }

      _this.updateSessionTime(_this.getPlayerTime(playerPosition));
      var currentTime = _this.currentSessionTime;
      var adBreak = _this.getCurrentOrNextAdBreak(avails, currentTime);

      if (!adBreak) {
        return;
      }

      // we get an ad break but it's empty
      if (!adBreak.ads || adBreak.ads.length < 1) {
        _this.destroy();
      }

      var hasAdsInQueue = !(0, _isEmpty2.default)(_this.queuedAdCollection);
      // ad break logic (avails): we need to keep track of which ad break we are in.
      if (!hasAdsInQueue || !_this.currentAdBreakId) {
        _this.currentAdBreakId = adBreak.availId; // set the ad break id
      } else if (_this.currentAdBreakId !== adBreak.availId) {
        // This is the case where currentAdBreakId is already set,
        // indicating there are still ads in a previous block that are playing.};
        // There is no need to digest ads from another ad break so just return.
        // currentAdBreakId will be cleared at the end of the ad break or on destroy.
        return;
      }

      // restore to false so that we can listen to when it changes to true, see listener
      if ((0, _applicationState.getState)(_applicationState.State.tuneRequested) === true) {
        (0, _applicationState.updateState)(_applicationState.State.tuneRequested, false);
      }

      _this.adList = adBreak.ads;

      if (hasAdsInQueue && forceUpdate) {
        // forceUpdate indicates that the queue may have been modified
        // and should be cleared & re-added
        _this.clearQueuedAds(_this.currentAdId);
      }

      // When currentAdId is set, then there is an ad already playing
      if (_this.currentAdId) {
        var currentAdIndex = (0, _findIndex2.default)(_this.adList, function (ad) {
          return _this.currentAdId === ad.adId;
        });
        // if the current ad is returned in the response, then
        // the next ad can simply be added because they are listed consecutively
        if (currentAdIndex !== -1) {
          _this.attemptToQueueNext(currentAdIndex);
          return;
        }
      }

      // ELSE currentAdId has not been set, no ad is playing
      var currentOrNext = _this.getCurrentOrNextAd(_this.adList, currentTime);
      if (!currentOrNext.ad) {
        return;
      }

      _logger2.default.debug('add the 1st valid ad (' + currentOrNext.ad.adId + ') from the response');
      _this.addToQueueOrUpdate(currentOrNext.ad);
      _this.attemptToQueueNext(currentOrNext.index); // attempt to queue the next ad as well
    };

    this.clearQueuedAds = function (currentAdIdOnForceUpdate) {
      _this.timedEventMap = {};
      (0, _forEach2.default)(_this.queuedAdCollection, function (ad) {
        if (currentAdIdOnForceUpdate !== ad.adId) {
          _this.removeAdFromQueue(ad.adId);
        }
      });

      // if there was an ad playing on force update, re-add the time events
      var currentAd = _this.queuedAdCollection[currentAdIdOnForceUpdate];
      if (currentAd) {
        _logger2.default.debug('[adId: ' + currentAdIdOnForceUpdate + '] forceUpdate, re-adding time events...');
        _this.setupTrackingEvents(currentAd);
        _this.setupEndOfAdEvents(currentAd);
      }
    };

    this.addToQueueOrUpdate = function (ad) {
      if ((0, _isEmpty2.default)(_this.queuedAdCollection)) {
        _this.startSessionTimer();
      }

      if (_this.queuedAdCollection[ad.adId]) {
        // do not add an item if it's already in the collection
        return;
      }

      _this.queuedAdCollection[ad.adId] = ad; // add to collection

      _this.setupTrackingEvents(ad);

      if (ad.startTimeInSeconds <= _this.currentSessionTime) {
        // if the ad is playing
        _logger2.default.debug('[adId: ' + ad.adId + '] tracking in progress, started at ' + Math.floor(ad.startTimeInSeconds));
        _this.startAd(ad);
      } else {
        _logger2.default.debug('[adId ' + ad.adId + '] tracking will start at ' + Math.floor(ad.startTimeInSeconds));
        _this.addToTimedEventMap(ad.startTimeInSeconds, {
          name: 'startAd',
          positionEventCallback: function positionEventCallback() {
            return _this.startAd(ad);
          }
        });
      }
    };

    this.attemptToQueueNext = function (index) {
      if (_this.adList.length <= 1) {
        return;
      }

      var nextAd = _this.adList[index + 1];
      if (!nextAd) {
        return;
      }

      _logger2.default.debug('add the next ad (' + nextAd.adId + ') from the response');
      _this.addToQueueOrUpdate(nextAd);
    };

    this.startAd = function (ad) {
      var adId = ad.adId;


      if (_this.currentAdId === adId) {
        // nothing more to do for an ad that's already started
        return;
      }

      _logger2.default.debug(adId + ' starting now, adbreak ' + _this.currentAdBreakId);

      if (_this.paused) {
        _this.paused = false;
      }
      _this.currentAdId = adId;
      _this.companionController.handleCompanionAds(ad); // sets this.adProvider
      _this.setupEndOfAdEvents(ad);

      // activate action event listeners for this particular ad (pause & resume)
      (0, _forEach2.default)(_this.actionEventListeners[_this.currentAdId], function (actionEvent) {
        actionEvent.addListener();
      });

      _this.companionController.set('currentAdRequestId', (0, _uuid.v4)());
      // log regular ad impression

      _this.companionController.set('audioSlotData', {
        name: 'instream',
        medium: 'audio',
        requestId: _this.companionController.currentAdRequestId,
        formatDefinition: {
          adProvider: _this.companionController.adProvider, // set in handleCompanionAds
          adUnitId: (0, _get2.default)(_this.companionController, 'adUnitIds.audio')
        }
      });

      _reporter2.default.impression(_this.companionController.audioSlotData);
      _palSdkController2.default.reportAdImpression();
      _this.companionController.showCompanionAds();
    };

    this.setupTrackingEvents = function (ad) {
      var trackingEvents = ad.trackingEvents;


      if (!trackingEvents || trackingEvents.length < 1) {
        return;
      }

      _this.actionEventListeners[ad.adId] = [];

      (0, _forEach2.default)(trackingEvents, function (event) {
        var handlerCreator = _this.eventTypeHandlerMap[event.eventType];
        var handlerInfo = handlerCreator && handlerCreator(ad, event);

        if (handlerInfo) {
          if (handlerInfo.invokedByPosition) {
            // time event (e.g. 'firstQuartile')
            _this.addToTimedEventMap(event.startTimeInSeconds, handlerInfo);
          } else {
            // action event (e.g. 'pause/resume')
            _this.actionEventListeners[ad.adId].push(handlerInfo);
          }
        }
      });
    };

    this.setupEndOfAdEvents = function (ad) {
      var adEndTime = ad.startTimeInSeconds + ad.durationInSeconds;
      var timeToPollForNextAd = adEndTime - 5;

      // add event to trigger polling for the next ad 5 seconds before end time
      _this.addToTimedEventMap(timeToPollForNextAd, {
        name: 'pollForNextAd',
        positionEventCallback: _this.pollForNextAd
      });

      // add event to tear down ad when finished
      _this.addToTimedEventMap(adEndTime, {
        name: 'tearDownAd',
        positionEventCallback: function positionEventCallback() {
          return _this.tearDownAd(ad.adId);
        }
      });
    };

    this.pollForNextAd = function () {
      _logger2.default.debug('poll for next ad');
      // gemini-web passes this event to web-tuner
      _mediaEvents2.default.event(_Events2.default.Type.instream, _Events2.default.Status.requestInstreamAds).emit();
    };

    this.tearDownAd = function (adId) {
      _logger2.default.debug('teardown ad: ' + adId);
      _this.removeAdFromQueue(adId);

      // if another ad starts at the same time, currentAdId may have already been set to a new value
      if (adId === _this.currentAdId) {
        _this.currentAdId = undefined;
      }

      // showOrRefreshAds in displayAdHandlers.js will not complete until after
      // the next ad in queuedAdCollection has been rendered, clearing it.
      // SO: we don't want to reset the display ads until the end of the ad break
      if ((0, _isEmpty2.default)(_this.queuedAdCollection)) {
        _this.handleEndOfAdBreak();
      }
    };

    this.removeAdFromQueue = function (adId) {
      // remove action event listeners
      (0, _forEach2.default)(_this.actionEventListeners[adId], function (handler) {
        if (handler.removeListener) {
          handler.removeListener();
        }
      });

      _this.actionEventListeners[adId] = []; // clear out handlers

      delete _this.queuedAdCollection[adId]; // remove ad from queue
    };

    this.handleEndOfAdBreak = function () {
      _logger2.default.debug('end of ad break');
      _this.currentAdBreakId = undefined;
      _this.companionController.resetCompanionsIfNeeded();
      // pollForNextAd is invoked here because the ad break logic ignores ads from
      // the next ad break until currentAdBreakId is reset
      _this.pollForNextAd();
    };

    this.startSessionTimer = function () {
      _this.resetSessionTimer();
      _this.sessionTimer.start();
    };

    this.resetSessionTimer = function () {
      _this.timedEventMap = {}; // clear events from previous session timer
      if (_this.sessionTimer) {
        _this.sessionTimer.stop();
      }
    };

    this.updateSessionTime = function (refreshedSessionTime) {
      // if queuedAdCollection is empty, we can safely just reset the currentSessionTime
      if (_this.currentSessionTime < refreshedSessionTime && !(0, _isEmpty2.default)(_this.queuedAdCollection)) {
        var numberOfSkippedSeconds = refreshedSessionTime - _this.currentSessionTime;
        for (var i = 0; i < numberOfSkippedSeconds; i++) {
          // onTimeChange will fire off any events that would be skipped and
          // increment this.currentSessionTime by 1
          _this.onTimeChange();
        }
      } else {
        _this.currentSessionTime = refreshedSessionTime;
      }
    };

    this.getPlayerTime = function () {
      var playerPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return playerPosition > 0 ? playerPosition : (0, _applicationState.getState)(_applicationState.State.positionInfo).elapsedSeconds || 0;
    };

    this.onTimeChange = function () {
      _logger2.default.debug('Instream session timer: ' + _this.currentSessionTime);

      // get any events that need to be fired at this second
      var eventsToFireNow = _this.timedEventMap[_this.currentSessionTime];
      if (eventsToFireNow) {
        if (_this.canSendEvents) {
          (0, _forEach2.default)(eventsToFireNow, function (handler) {
            handler.positionEventCallback();
          });
        } else {
          _logger2.default.debug('Unable to send events because status = ' + (0, _applicationState.getState)(_applicationState.State.playerStatus));
        }

        // clear the events for this point in time
        delete _this.timedEventMap[_this.currentSessionTime];
      }

      // increment the currentSessionTime
      _this.currentSessionTime = _this.currentSessionTime + 1;
    };

    this.onPlayerStatusChange = function (status) {
      // it SOMETIMES plays when the status is connecting... so allowing those events to send
      _this.canSendEvents = status === _constants.PlayStates.playing || status === _constants.PlayStates.connecting;

      // once stopped, the stream will have to retune and will refresh the ad data.
      if (status === _constants.PlayStates.stopped || status === _constants.PlayStates.error) {
        _this.destroy();
      }
    };

    this.onTuneRequested = function (wasRequested) {
      if (wasRequested) {
        _this.destroy();
      }
    };

    this.updateInstreamParams = function () {
      var instreamParams = _networkUrlBuilder2.default.getInstreamCustomParams();
      _mediaEvents2.default.event(_Events2.default.Type.instream, _Events2.default.Status.updateInstreamParams).emit(instreamParams);
    };

    this.invokeTracking = function (event) {
      var trackingUrls = event.beaconUrls || [];
      (0, _forEach2.default)(trackingUrls, function (url) {
        _logger2.default.debug('tracking event \'' + event.eventType + '\' fired');
        _axios2.default.get(url);
      });
    };

    this.getPauseHandler = function (event) {
      return function (playerStatus) {
        if (_this.paused === false && playerStatus === _Events2.default.Status.paused) {
          _this.invokeTracking(event);
          _this.paused = true;
        }
      };
    };

    this.getResumeHandler = function (event) {
      return function (playerStatus) {
        if (_this.paused === true && playerStatus === _Events2.default.Status.playing) {
          _this.invokeTracking(event);
          _this.paused = false;
        }
      };
    };

    this.isCurrentOrNextPredicate = function (currentTimeInSeconds, startTimeInSeconds, durationInSeconds) {
      var endTime = startTimeInSeconds + durationInSeconds;
      // return the first item that has not started/ended yet
      return currentTimeInSeconds < endTime;
    };

    this.getCurrentOrNextAdBreak = function (avails, currentTime) {
      return (0, _find2.default)(avails, function (avail) {
        return _this.isCurrentOrNextPredicate(currentTime, avail.startTimeInSeconds, avail.durationInSeconds);
      });
    };

    this.getCurrentOrNextAd = function (adList, currentTime) {
      var firstAdIndex = 0;

      var firstAd = (0, _find2.default)(adList, function (ad, index) {
        if (_this.isCurrentOrNextPredicate(currentTime, ad.startTimeInSeconds, ad.durationInSeconds)) {
          firstAdIndex = index;
          return true;
        }
        return false;
      });

      return {
        ad: firstAd,
        index: firstAdIndex
      };
    };

    this.eventTypeHandlerMap = {
      resume: function resume(ad, event) {
        return {
          adId: ad.adId,
          name: 'resume',
          invokedByPosition: false,
          addListener: function addListener() {
            return (0, _applicationState.addStateChangeListener)(_applicationState.State.playerStatus, _this.getResumeHandler(event));
          },
          removeListener: function removeListener() {
            return (0, _applicationState.removeStateChangeListener)(_applicationState.State.playerStatus, _this.getResumeHandler(event));
          }
        };
      },
      pause: function pause(ad, event) {
        return {
          adId: ad.adId,
          name: 'pause',
          invokedByPosition: false,
          addListener: function addListener() {
            return (0, _applicationState.addStateChangeListener)(_applicationState.State.playerStatus, _this.getPauseHandler(event));
          },
          removeListener: function removeListener() {
            return (0, _applicationState.removeStateChangeListener)(_applicationState.State.playerStatus, _this.getPauseHandler(event));
          }
        };
      },
      start: function start(ad, event) {
        return {
          adId: ad.adId,
          name: 'start',
          invokedByPosition: true,
          positionEventCallback: function positionEventCallback() {
            return _this.invokeTracking(event);
          }
        };
      },
      complete: function complete(ad, event) {
        return {
          adId: ad.adId,
          name: 'complete',
          invokedByPosition: true,
          positionEventCallback: function positionEventCallback() {
            return _this.invokeTracking(event);
          }
        };
      },
      creativeView: function creativeView(ad, event) {
        return {
          adId: ad.adId,
          name: 'creativeView',
          invokedByPosition: false, // should always be invoked regardless of start time
          addListener: function addListener() {
            return _this.invokeTracking(event);
          }
        };
      },
      impression: function impression(ad, event) {
        return {
          adId: ad.adId,
          name: 'impression',
          invokedByPosition: false, // should always be invoked regardless of start time
          addListener: function addListener() {
            return _this.invokeTracking(event);
          }
        };
      },
      firstQuartile: function firstQuartile(ad, event) {
        return {
          adId: ad.adId,
          name: 'firstQuartile',
          invokedByPosition: true,
          positionEventCallback: function positionEventCallback() {
            return _this.invokeTracking(event);
          }
        };
      },
      midpoint: function midpoint(ad, event) {
        return {
          adId: ad.adId,
          name: 'midpoint',
          invokedByPosition: true,
          positionEventCallback: function positionEventCallback() {
            return _this.invokeTracking(event);
          }
        };
      },
      thirdQuartile: function thirdQuartile(ad, event) {
        return {
          adId: ad.adId,
          name: 'thirdQuartile',
          invokedByPosition: true,
          positionEventCallback: function positionEventCallback() {
            return _this.invokeTracking(event);
          }
        };
      }
    };

    this.setInitialState();
  }

  /*
  *  When the HLS player indicates there are ads to process,
  *  an event is fired and the ad metadata is passed here.
  *
  *  This happens manually on tune, and 5 seconds before the end of an ad that's already queued.
  *  This also happens when events are fired via the player to indicate an ad break is
  *  starting or ending/updating
  *
  *  The adMetadata param consists of three items:
  *  1. avails [array]
  *     each avails is an ad break that consists of an array of ads
  *
  *  2. playerPostion (number)
  *     The elapsedSeconds current state of the tuner
  *
  *  3. forceUpdate (bool)
  *     Defaults to false, when true this means that the time events currently queued
  *     need to be re-evaluated and re-set.
  */


  // this function is used to clear any ads in the queue excluding the currently playing ad
  // - the ad break may have been adjusted/cut off (i.e. the forceUpdate flag)
  // - only the timed events need to be reset,
  // - the action events are only enabled once the ad has started, so no need to modify


  _createClass(InstreamAvailsController, [{
    key: 'addToTimedEventMap',
    value: function addToTimedEventMap(timeToInvoke, eventHandlerInfo) {
      if (timeToInvoke < this.currentSessionTime) {
        return;
      }
      var flooredTimeToInvoke = Math.floor(timeToInvoke);
      if (!this.timedEventMap[flooredTimeToInvoke]) {
        this.timedEventMap[flooredTimeToInvoke] = [];
      }

      this.timedEventMap[flooredTimeToInvoke].push(eventHandlerInfo);
    }

    /*
      updateSessionTime compares the currentSessionTime to the refreshedSessionTime which
      comes from the player state. This is to prevent the session timer from becoming too
      out of sync with the instream ads timer.
       If there is a gap, then the onTimeChange is called to fire any time events
      and will also update the currentSessionTime
    */


    // when processing data from a new tune, everything should be reset


    /*
      isCurrentOrNextPredicate
      This is a utility function that is used when looping through a list of
      consecutive ads or avails to find the currently playing item or the next item
       If we are in the middle of an ad/ad break, we want the current item.
      However, if the ad break hasn't started yet, we want to select the first item that hasn't
      started/ended yet.
       Each ad in the list often has the exact end time as the start time of the next ad.
      - exported for testing -
    */


    // avails helper


    // avails helper

  }]);

  return InstreamAvailsController;
}();

exports.default = InstreamAvailsController;